import { render, staticRenderFns } from "./FindTalent.vue?vue&type=template&id=84555a2a&scoped=true&"
import script from "./FindTalent.vue?vue&type=script&lang=js&"
export * from "./FindTalent.vue?vue&type=script&lang=js&"
import style0 from "./FindTalent.vue?vue&type=style&index=0&id=84555a2a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "84555a2a",
  null
  
)

export default component.exports